module.exports = __webpack_public_path__ + "images/Engineering Ethics in Web3.pdf?v=871559568ffc8c270a63b1680f38a008";